<template>
  <div
    id="download-methodology"
    ref="target"
    :class="{
      '!bg-s-600': isDropdownOpen,
      '!bg-s-400 !cursor-default': downloading,
    }"
    class="default-button-height relative flex cursor-pointer select-none items-center justify-between rounded bg-s-900 px-4 text-sm text-white"
    @click="handleDropdownClick"
  >
    <div class="flex items-center">
      <IconDownload v-if="!downloading" class="h-5 w-5 p-0.5" />
      <IconSpinner v-else class="h-5 w-5 animate-spin" />
      <span class="ml-2 mr-[37px] font-semibold">Methodology</span>
    </div>
    <ChevronDown
      :class="{ 'rotate-180': isDropdownOpen }"
      class="h-5 w-5 transition-transform"
    />

    <div
      v-if="isDropdownOpen"
      class="absolute left-0 top-[calc(100%_+_4px)] z-10 w-full cursor-pointer rounded bg-white text-black transition-all"
      style="box-shadow: 0 1px 10px 0 #c1c5cf"
    >
      <div
        v-if="brochureFileInfo"
        class="border-b border-s-300 p-4 transition-colors hover:bg-s-100"
        @click="downloadReport(brochureFileInfo, brochureFileInfo.category)"
      >
        Price Assessment
      </div>
      <div
        v-if="customisationToolBrochureFileInfo"
        class="p-4 transition-colors hover:bg-s-100"
        @click="
          downloadReport(
            customisationToolBrochureFileInfo,
            customisationToolBrochureFileInfo.category,
          )
        "
      >
        Price Customisation Tool
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { onClickOutside } from '@vueuse/core'
import ChevronDown from '~/assets/icons/ChevronDown.svg'
import IconDownload from '~/assets/icons/IconDownload.svg'
import { useDownloadReport } from '~/composables/useDownloadReport'

const IconSpinner = defineAsyncComponent(
  () => import('~/assets/icons/Spinner.svg'),
)

defineProps<{
  brochureFileInfo?: Record<string, any>
  customisationToolBrochureFileInfo?: Record<string, any>
}>()

const target = ref(null)
const loading = ref(true)
const isDropdownOpen = ref(false)

const handleDropdownClick = () => {
  if (loading.value) {
    isDropdownOpen.value = false
    return
  }
  isDropdownOpen.value = !isDropdownOpen.value
}

const closeDropdown = () => {
  isDropdownOpen.value = false
}

onClickOutside(target, () => {
  closeDropdown()
})

const { downloadReport, downloading } = useDownloadReport()

onMounted(() => {
  setTimeout(() => {
    loading.value = false
  }, 50)
})
</script>
